<template>
  <el-popover
    v-model="show"
    placement="bottom-start"
    :visible-arrow="false"
    :disabled="disableUse"
    popper-class="color-picker-popper"
    trigger="click"
    @show="afterEnter"
    @hide="afterLeave"
  >
    <div
      role="application"
      aria-label="Sketch color picker"
      :class="['vc-sketch', disableAlpha ? 'vc-sketch__disable-alpha' : '']"
      @mouseup="clickColorUp"
    >
      <div
        v-if="!disableAlpha"
        class="vc-sketch-presets no-color"
        role="group"
        aria-label="A color preset, pick one to set as current color"
      >
        <div
          :aria-label="'Color:' + 'rgba(0,0,0,0)'"
          class="vc-sketch-presets-color"
          @click="handlePreset('rgba(0,0,0,0)')"
        >
          <checkboard />
        </div>
        <span>无颜色</span>
      </div>
      <div
        class="vc-sketch-presets"
        role="group"
        aria-label="A color preset, pick one to set as current color"
      >
        <template v-for="c in presetColors">
          <div
            v-if="!isTransparent(c)"
            :key="c"
            class="vc-sketch-presets-color"
            :aria-label="'Color:' + c"
            :style="{background: c}"
            @click="handlePreset(c)"
          />
          <div
            v-else
            :key="c"
            :aria-label="'Color:' + c"
            class="vc-sketch-presets-color"
            @click="handlePreset(c)"
          >
            <checkboard />
          </div>
        </template>
      </div>
      <div
        v-if="lateUseColor"
        class="vc-sketch-latest"
        role="group"
        aria-label="最近选择的颜色"
      >
        <span style="display: inline-block; vertical-align: text-top;padding-bottom: 10px; font-size: 12px;">最近使用</span>
        <template v-for="c in lateUseColor">
          <div
            v-if="!isTransparent(c)"
            :key="c"
            class="vc-sketch-presets-color"
            :aria-label="'Color:' + c"
            :style="{background: c}"
            @click="handlePreset(c)"
          />
          <div
            v-else
            :key="c"
            :aria-label="'Color:' + c"
            class="vc-sketch-presets-color"
            @click="handlePreset(c)"
          >
            <checkboard />
          </div>
        </template>
      </div>
      <div class="vc-sketch-op-wrap">
        <div class="vc-sketch-saturation-wrap">
          <saturation
            v-model="colors"
            @change="childChange"
          />
        </div>
        <div class="vc-sketch-controls">
          <div class="vc-sketch-sliders">
            <div class="vc-sketch-hue-wrap">
              <hue
                v-model="colors"
                @change="childChange"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!disableAlpha"
        class="vc-sketch-alpha-wrap"
      >
        <alpha
          v-model="colors"
          @change="childChange"
        />
      </div>
      <div
        v-if="!disableFields"
        class="vc-sketch-field"
      >
        <!-- rgba -->
        <div class="vc-sketch-color-wrap">
          <div
            :aria-label="`Current color is ${activeColor}`"
            class="vc-sketch-active-color"
            :style="{background: activeColor}"
          />
          <checkboard />
        </div>
        <div class="vc-sketch-field--double">
          <ed-in
            label="hex"
            :value="hex"
            @change="inputChange"
          />
        </div>
      </div>
    </div>
    <div
      slot="reference"
      class="attr-select-wrap"
      :class="{disabled: disableUse}"
      @click="btnclick"
    >
      <div
        v-if="disableUse"
        class="model"
      />
      <span class="color-wrap">
        <div
          v-if="!isTransparent(activeColor)"
          :key="activeColor"
          class="vc-sketch-presets-color"
          :aria-label="'Color:' + activeColor"
          :style="{background: activeColor}"
          @click="handlePreset(activeColor)"
        />
        <div
          v-else
          :key="activeColor"
          :aria-label="'Color:' + activeColor"
          class="vc-sketch-presets-color"
          @click="handlePreset(activeColor)"
        >
          <checkboard />
        </div>
      </span>
      <span
        class="arrow el-icon-caret-bottom"
        :class="{'is-reverse': active}"
      />
    </div>
  </el-popover>
</template>

<script>
import colorMixin from '../mixin/color';
import editableInput from './common/EditableInput.vue';
import saturation from './common/Saturation.vue';
import hue from './common/Hue.vue';
import alpha from './common/Alpha.vue';
import checkboard from './common/Checkboard.vue';

const presetColors = [
    '#000000', '#ffffff', '#ff0000', '#1f497d', '#4f81bd', '#c0504d',
    '#9bbb59', '#8064a2', '#4bacc6', '#f79646', '#555555',
    '#c00000', '#ffc000', '#ffff00', '#92d050', '#00b050',
    '#00b0f0', '#0070c0', '#002060', '#7030a0',
];

export default {
    name: 'ColorPicker',
    components: {
        saturation,
        hue,
        alpha,
        'ed-in': editableInput,
        checkboard,
    },
    mixins: [colorMixin],
    props: {
        presetColors: {
            type: Array,
            default () {
                return presetColors;
            },
        },
        disableUse: {
            type: Boolean,
            default: false,
        },
        disableAlpha: {
            type: Boolean,
            default: false,
        },
        disableFields: {
            type: Boolean,
            default: false,
        },
        saveKey: {
            type: [String, Number],
            default: 'myColorpicker',
        },
        stroage: {
            type: Object,
            default () {
                return window.yxpapi.stroage.persistent;
            },
        },

    },
    data () {
        return {
            lateUseColor: (() => {
                return this.stroage.get(this.saveKey + '.color');
            })(),
            active: false,
            show: false,
        };
    },
    computed: {
        hex () {
            if (this.disableAlpha) {
                return `rgba(${this.colors.rgba.r},${this.colors.rgba.b},${this.colors.rgba.b})`;
            } else {
                return `rgba(${this.colors.rgba.r},${this.colors.rgba.b},${this.colors.rgba.b},${this.colors.rgba.a})`;
            }
        },
        activeColor () {
            var rgba = this.colors.rgba;
            if (this.disableAlpha) {
                return 'rgba(' + [rgba.r, rgba.g, rgba.b].join(',') + ')';
            } else {
                return 'rgba(' + [rgba.r, rgba.g, rgba.b, rgba.a].join(',') + ')';
            }
        },
    },
    beforeDestroy () {
        if (this.show) {
            this.afterLeave();
        }
    },
    methods: {
        btnclick () {
            var self = this;
            setTimeout(function () {
                if (self.show) {
                    self.$emit('openPicker', self.colors);
                }
            });
        },
        clickColorUp (event) {
            // 不是实时变化的颜色的情况，添加鼠标up时再发出选中颜色值
            var self = this;
            setTimeout(function () {
                if (self.show) {
                    self.$emit('pickerUp', self.colors);
                }
            });
        },
        handlePreset (c) {
            this.colorChange({
                hex: c,
                source: 'hex',
            });
        },
        afterEnter () {
            this.lateUseColor = this.stroage.get(this.saveKey + '.color');
            this.active = true;
        },
        childChange (data) {
            this.colorChange(data);
        },
        inputChange (data) {
            if (!data) {
                return;
            }
            if (data.hex) {
                console.log(8888, this.isValidHex(data.hex));
                this.isValidHex(data.hex) && this.colorChange({
                    hex: data.hex,
                    source: 'hex',
                });
            } else if (data.r || data.g || data.b || data.a) {
                this.colorChange({
                    r: data.r || this.colors.rgba.r,
                    g: data.g || this.colors.rgba.g,
                    b: data.b || this.colors.rgba.b,
                    a: data.a || this.colors.rgba.a,
                    source: 'rgba',
                });
            }
        },
        afterLeave () {
            if (!this.stroage.get(this.saveKey + '.color')) {
                this.stroage.set(this.saveKey + '.color', [this.activeColor]);
            } else {
                let color = this.stroage.get(this.saveKey + '.color');
                if (!color.includes(this.activeColor)) {
                    color.unshift(this.activeColor);
                }
                this.stroage.set(this.saveKey + '.color', color.slice(0, 6));
            }
            this.active = false;
            this.$emit('closePicker', this.colors);
            // this.value.num *= Math.random()
            // this.$set(this.value, 'num', this.value.num * Math.random())
            // console.log(123, this.value)
        },
    },
};
</script>

<style>
    .vc-sketch {
        position: relative;
        width: 224px;
        padding: 2px 10px;
        box-sizing: initial;
        background: #fff;
        /* border-radius: 4px; */
        /* box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15); */
    }

    .vc-sketch-op-wrap {
        width: 100%;
        height: 150px;
        position: relative;
        display: flex;
        overflow: hidden;
    }

    .vc-sketch-saturation-wrap {
        flex: 0 0 88%;
        height: 150px;
        /* padding-bottom: 75%; */
        position: relative;
        overflow: hidden;
    }

    .attr-select-wrap{
        display: inline-flex;
        width: 76px;
        height: 32px;
        border: 1px solid #d2e3eb;
        background-color: #fff;
        cursor: pointer;
        position: relative;
    }

    .attr-select-wrap.disabled {
        cursor: no-drop;
    }

    .attr-select-wrap .model {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background-color: rgba(256, 256, 256, .5)
    }

    .color-wrap{
        flex: 0 0 49px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #d2e3eb;
    }

    .color-wrap .vc-sketch-presets-color{
        margin: 0;
    }

    .color{
        flex: 0 0 20px;
        height: 20px;
        border: 1px solid #e6edf2;
    }

    .arrow{
        flex: 0 0 25px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: #f0f6fc;
    }

    .arrow:before {
        transition: transform .3s;
    }

    .arrow.is-reverse:before {
        transform: rotateZ(180deg);
    }

    .vc-sketch-controls {
        flex: 0 0 12%;
        padding-left: 10px;
        /* display: inline-flex; */
    }

    .vc-sketch-sliders {
        width: 100%;
        height: 100%;
        display: inline-flex;
        justify-content: flex-end;
    }

    .vc-sketch-sliders .vc-hue,
    .vc-sketch-sliders .vc-alpha-gradient {
        border-radius: 2px;
    }

    .vc-sketch-hue-wrap {
        flex: 0 0 20px;
        position: relative;
        height: 100%;
    }

    .vc-sketch-alpha-wrap {
        /* flex: 0 0 20px; */
        margin-top: 8px;
        width: 100%;
        position: relative;
        height: 20px;
        overflow: hidden;
    }

    .vc-sketch-color-wrap {
        width: 50px;
        height: 20px;
        position: relative;
        margin-top: 2px;
        /* margin-left: 4px; */
        /* border-radius: 3px; */
    }

    .vc-sketch-active-color {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 2px;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);
        z-index: 2;
    }

    .vc-sketch-color-wrap .vc-checkerboard {
        background-size: auto;
    }

    .vc-sketch-field {
        display: flex;
        padding-top: 4px;
        justify-content: space-between;
    }

    .vc-sketch-field .vc-input__input {
        width: 100%;
        height: 20px;
        padding: 4px 0 3px 10%;
        border: none;
        box-shadow: inset 0 0 0 1px #ccc;
        font-size: 10px;
    }

    .vc-sketch-field .vc-input__label {
        display: block;
        text-align: center;
        font-size: 11px;
        color: #222;
        padding-top: 3px;
        padding-bottom: 4px;
        text-transform: capitalize;
    }

    .vc-sketch-field--single {
        flex: 1;
        padding-left: 6px;
    }

    .vc-sketch-field--double {
        flex: 2;
        padding-left: 20px;
    }

    .vc-sketch-presets {
        margin-right: -10px;
        margin-left: -10px;
        padding-left: 10px;
    }
    .vc-sketch-presets.no-color{
        background-color: #eff3fa;
        margin-bottom: 10px;
        text-align: center;
        color:#333;
        font-size: 12px;
        line-height: 30px;
    }
    .vc-sketch-presets.no-color .vc-sketch-presets-color{
        margin: 0;
        margin-right: 6px;
        vertical-align: text-top;
    }
    .vc-sketch-latest {
        padding-top: 10px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .vc-sketch-presets-color {
        /* border-radius: 3px; */
        overflow: hidden;
        position: relative;
        display: inline-block;
        margin: 0 5px 5px 0;
        vertical-align: top;
        cursor: pointer;
        width: 18px;
        height: 18px;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);
    }

    .vc-sketch-presets-color .vc-checkerboard {
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);
        border-radius: 3px;
    }

    /* .vc-sketch__disable-alpha .vc-sketch-color-wrap {
      height: px;
    } */
</style>
